import { ChangeEvent, forwardRef } from 'react';
import { IMaskInput } from 'react-imask';
import { InputMask } from 'imask';
import { TagNumberPatternMaskProps } from '../FormTagNumberField.types';

export const TagNumberPatternMask = forwardRef<HTMLInputElement, TagNumberPatternMaskProps>(({ onChange, ...props }, ref) => {

    /**
     * This handles the callback to our input element onChange.
     * We have to construct a psuedo change event manually to pass it to the
     * input element onChange.
     */
    const handleAccept = (value: string, masked: InputMask, el: InputEvent | undefined) => {
        if (onChange) {
            const syntheticEvent = {
                ...el,
                target: {
                    ...el,
                    value: value,
                    selectionEnd: masked._selection.end,
                },
            } as ChangeEvent<HTMLInputElement | HTMLTextAreaElement>;

            onChange(syntheticEvent);
        }
    };

    return (
        <IMaskInput
            {...props}
            mask={'XXXX'}
            definitions={{
                'X': /./,
            }}
            inputRef={ref}
            onAccept={handleAccept}
        />
    );
});